import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import Progress from 'react-progress-2';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Home from '../Home';
import About from '../About';
import Blog from '../Blog';

class App extends Component {
    render() {
        return (
            <div className="outer-content-wrapper">
                <Progress.Component />
                <Header />
                <Switch>
                    <Route exact path="/" component={Home} />
                    <Route path="/about" component={About} />
                    <Route path="/blog" component={Blog} />
                </Switch>
                <Footer />
            </div>
        )
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/containers/App/index.js